// extracted by mini-css-extract-plugin
export var content = "_qc-1";
export var fullScreen = "_qc-0";